import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";

export const tipoPromocao = (tipo: number) => {
  switch (tipo) {
    case 1:
      return "Pague leve";
    case 2:
      return "Desconto progressivo";
    default:
      return "";
  }
};

export const aplicarPara = (tipo: number) => {
  switch (tipo) {
    case 1:
      return "Produtos";
    case 2:
      return "Departamentos";
    case 3:
      return "Categorias";
    default:
      return "";
  }
};

export interface PromocaoTableType {
  id: number;
  codigo: number;
  descricao: string;
  inativo: boolean;
  tipoDesconto: number;
  aplicarPara: number;
  ilimitada: boolean;
  dataInicio: string;
  dataFim: string;
}

export interface PagueLeve {
  pague: number;
  leve: number;
}

export interface DescontoMultiplo {
  quantidade: number;
  desconto: number;
}
export interface ProdutoPromo {
  id?: number;
  promocaoId?: number;
  produtoId?: number;
  departamentoId?: number;
  categoriaId?: number;
  empresas: any[];
}
export interface PromocaoRequest {
  codigo?: number;
  descricao: string;
  inativo: boolean;
  tipoDesconto: number;
  dataInicio?: Date;
  dataFim?: Date;
  ilimitada: boolean;
  acumulativa: boolean;
  pagueLeve: PagueLeve;
  descontoMultiplo?: DescontoMultiplo[];
  aplicarPara: number;
  produtoPromocoes: ProdutoPromo[];
  empresasAssociadas: number[];
}

export const promocoesBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Cadastros",
    url: "#!",
  },
  {
    label: "Promoções",
    active: true,
  },
];

export const promocaoBreadcrumbItems = (
  codigo?: number
): PageBreadcrumbItem[] => [
  {
    label: "Cadastros",
    url: "#!",
  },
  {
    label: "Promoções",
    url: "/cadastros/promocoes",
  },
  {
    label: codigo?.toString() ? "Editar" : "Nova",
    active: true,
  },
];
